import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-logiciel-caisse-pos-pagination',
  templateUrl: './logiciel-caisse-pos-pagination.component.html',
  styleUrls: ['./logiciel-caisse-pos-pagination.component.scss'],
})
export class LogicielCaissePosPaginationComponent implements OnInit, OnChanges {
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() totalItems = 0;
  @Input() pageSize = 10;
  @Input() pageSizeOptions: number[] = [10, 25, 50, 100];

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  pages: number[] = [1];

  ngOnInit(): void {
    this.rebuildPages();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalPages'] || changes['currentPage']) {
      this.rebuildPages();
    }
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.currentPage) {
      return;
    }
    this.pageChange.emit(page);
  }

  onPageSizeChange(size: number): void {
    this.pageSizeChange.emit(size);
  }

  private rebuildPages(): void {
    const n = Math.max(1, this.totalPages);
    this.pages = Array.from({ length: n }, (_, i) => i + 1);
  }
}
